import { showMessage } from './MessageUtility';

let currentStream: MediaStream | null = null;

const GlobalStreamManager = Object.freeze({
  get stream(): MediaStream | null {
    return currentStream;
  },

  async open(constraints: MediaStreamConstraints = { video: true, audio: false }): Promise<MediaStream> {
    // Close existing stream if any
    this.close();

    try {
      currentStream = await navigator.mediaDevices.getUserMedia(constraints);
      return currentStream;
    } catch (error: any) {
      console.error('Failed to open camera stream:', error);

      let errorMessage = 'Camera access denied or unavailable';
      if (error.name === 'NotAllowedError') {
        errorMessage = 'Camera permission denied. Please allow camera access and try again.';
      } else if (error.name === 'NotFoundError') {
        errorMessage = 'No camera found. Please connect a camera and try again.';
      } else if (error.name === 'NotReadableError') {
        errorMessage = 'Camera is already in use by another application.';
      }

      showMessage('error', errorMessage);
    }
  },

  capture(videoElement: HTMLVideoElement): string {
    if (!currentStream) {
      const errorMessage = 'No active camera stream';
      showMessage('error', errorMessage);
    }

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) {
      const errorMessage = 'Unable to create canvas context';
      showMessage('error', errorMessage);
    }

    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/jpeg', 0.8);
  },

  close(): void {
    if (currentStream) {
      currentStream.getTracks().forEach((track) => track.stop());
      currentStream = null;
    }
  }
});

export default GlobalStreamManager;
